export default function BrandLogo({ className = "h-10 w-auto", eager = false }) {
  return (
    <img
      src="/vagenpar-logo.svg"
      alt="VAGenpar"
      className={`block object-contain ${className}`}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
    />
  );
}
